module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_7.a0f10fa7.png";